import { FormikHelpers } from "formik";
import { FormikInputWithLabel } from "newui/components/ui/InputWithLabel"

interface EmailFieldProps {
	emailDataTestid: string;
	setFieldValue?: FormikHelpers<any>["setFieldValue"];
}

export const EmailField = ({ emailDataTestid, setFieldValue }: EmailFieldProps) => {
	return <FormikInputWithLabel
		id="email"
		label="Email"
		name="email"
		type="email"
		placeholder="Enter your email"
		className="col xl-12"
		data-testid={emailDataTestid}
		setFieldValue={setFieldValue}
		autoComplete="username"
		aria-required="true"
		maxLength={190}
		required
	/>
}